var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M19.53 10.47a.75.75 0 01-1.06 1.06l-5.72-5.72V20c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.75-.75V5.81l-5.72 5.72a.75.75 0 01-.98.07l-.08-.07a.75.75 0 010-1.06l7-7c.3-.3.77-.3 1.06 0z"}})}
var staticRenderFns = []

export { render, staticRenderFns }